var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 53,
    fill: "#F1F1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0129 24.198L55.0097 56.0214L77.4801 78.4918",
    stroke: "#DDDDED",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.182 10.2295V29.5022H84.9089",
    stroke: "#DDDDED",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9997 109C26.7286 109 2.99969 85.2711 2.99969 56C2.99969 26.7289 26.7286 3 55.9997 3C75.615 3 92.7416 13.6559 101.906 29.4948",
    stroke: "#DDDDED",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109 56C109 85.2711 85.2711 109 56 109",
    stroke: "#DDDDED",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.8 8.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.b82e629ecb6f895a3528fb5d3597c135.svg";
export { ForwardRef as ReactComponent };